// extracted by mini-css-extract-plugin
export default {"widht":"styles_widht__g71fo","overly":"styles_overly__YON-q","hidden":"styles_hidden__Humxw"};